import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const AnimatedGif: React.FC<{
  src: string;
  staticSrc: string;
  alt: string;
}> = ({ src, staticSrc, alt }) => {
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setPaused(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <img src={paused ? staticSrc : src} className="img-fluid" alt={alt} />
      <button
        className="btn btn-sm btn-outline-light mt-1"
        onClick={() => setPaused(!paused)}
        aria-label={paused ? "Play animation" : "Pause animation"}
      >
        <i
          className={`fas fa-${paused ? "play" : "pause"}`}
          aria-hidden="true"
        ></i>{" "}
        {paused ? "Play" : "Pause"} animation
      </button>
    </div>
  );
};

const StreamDigital: React.FC = () => {
  return (
    <div className="container-fluid section" id="section_1">
      <div className="container  py-5">
        <div className="row">
          <div className="col-md-4">
            <AnimatedGif
              src={process.env.REACT_APP_CDN_IMG + "2021-08-03.gif"}
              staticSrc="https://flangoo-cdn.s3.us-east-2.amazonaws.com/frida-home-gif-static.jpg"
              alt="Titles: Frida soy complicada, Le Fantôme de l’Opéra, Pobresita Ana, Petra reist nach Kalifornien, and many more! Animated GIF showing book covers."
            />
          </div>

          <div className="col-md-8">
            <h2 className="text-left">
              Stream Digital Short Stories and Novels in Your World Language
              Class
            </h2>
            <ul className="checkmarks">
              <li>
                {" "}
                <img
                  src={process.env.REACT_APP_CDN_IMG + "orange-checkmark.png"}
                  alt=""
                />{" "}
                <p>Seamlessly switch between at-home and in-class use</p>
              </li>
              <li>
                {" "}
                <img
                  src={process.env.REACT_APP_CDN_IMG + "orange-checkmark.png"}
                  alt=""
                />{" "}
                <p>
                  One teacher account includes all three languages, over 400
                  titles, and access for all of that teacher's students
                </p>
              </li>
              <li>
                {" "}
                <img
                  src={process.env.REACT_APP_CDN_IMG + "orange-checkmark.png"}
                  alt=""
                />{" "}
                <p>No software to install—Flangoo works on any device!</p>
              </li>
            </ul>
            <Link to="/signup" className="btn btn-warning ">
              Start Your Free Trial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreamDigital;
